import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="white_papers" />;

export const Route = createFileRoute("/zh-cn/downloads/$slug")({
  loader: ({ params }) => loadContentMeta("white_papers", params.slug, "zh-cn"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/downloads/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

